<template>
  <div>
    <!-- <header class="header" v-if="isStudent">
      <button
        class="btn btn--border-grey st-qr-fixed"
        @click="showQRPopup = true"
        tabindex="0"
      >
        <icon name="header__sb-btn-icon-2" width="32" height="32" />
        <span>תעודה שלי</span>
      </button>
      <ul
        v-click-outside="() => (showCampusSelect = false)"
        class="school-switcher__list"
      >
        <li
          v-for="campus of campuses"
          :key="campus.id"
          class="school-switcher__list-item"
          :class="{
            active: selectedCampus ? selectedCampus.id === campus.id : false
          }"
          @click="selectCampus(campus)"
        >
          <div class="school-switcher__list-item-logo">
            <img v-if="campus.logo" :src="campus.logo" alt="" />
            <img v-else src="/images/sm-logo.svg" alt="" />
          </div>
          <div class="school-switcher__list-item-info">
            <div class="school-switcher__list-item-title">
              {{ campus.text }}
            </div>
            <div class="school-switcher__list-item-text">פנימייה</div>
          </div>
        </li>
      </ul>
    </header> -->
    <header
      class="header"
      :class="{ moved: showMenu }"
      @click.self="closeUserAvatarHeader"
    >
      <div
        class="header__menu-btn"
        :class="{ active: showSidebar }"
        @click="hideSidebar()"
      >
        <icon name="menu-new-icon" class="header__sb-btn-icon-1" />
        <icon name="menu-new-icon" class="header__sb-btn-icon-2" />
      </div>
      <div :class="'header__sb-btn d-none'" @click="hideSidebar">
        <icon name="menu-new-icon" class="header__sb-btn-icon-1" />
        <icon name="menu-new-icon" class="header__sb-btn-icon-2" />
      </div>
      <div class="header__mob-group d-lg-none mr-md-2">
        <div class="header__notification disabled d-md-none">
          <div class="header__notification-status" />
          <div class="header__notification-icon">
            <icon name="header__notification-icon" />
          </div>
        </div>
      </div>
      <ul class="header__controls d-none d-md-flex">
        <li
          class="
            header__controls-item
            header-tools__settings-item
            header__controls--disabled
          "
        >
          <a
            href="https://www.smart-campus.co.il/"
            target="_blank"
            class="header__controls-link"
            tabindex="0"
          >
            <div class="header__controls-counter header__controls-counter--red">
              8
            </div>
            <icon name="header__controls-link-1" />
          </a>
          <div class="tooltip left">עדכונים (בקרוב)</div>
        </li>
        <li class="header__controls-item">
          <router-link
            to="/calendar"
            class="header__controls-link"
            active-class="active"
            tabindex="0"
          >
            <div class="header__controls-counter" />
            <icon name="header__controls-link-2" />
          </router-link>
          <div class="tooltip bot">יומן (בקרוב)</div>
        </li>
        <li class="header__controls-item header__controls--disabled">
          <a href="" class="header__controls-link" tabindex="0">
            <div class="header__controls-counter" />
            <icon name="header__controls-link-3" />
          </a>
          <div class="tooltip bot">משימות (בקרוב)</div>
        </li>
        <li class="header__controls-item header__controls--disabled">
          <a href="" class="header__controls-link" tabindex="0">
            <div class="header__controls-counter" />
            <icon name="header__controls-link-4" />
          </a>
          <div class="tooltip bot">משמרות (בקרוב)</div>
        </li>
        <!--        <li class="header__controls-item header__controls&#45;&#45;disabled">-->
        <!--          <a href="" class="header__controls-link">-->
        <!--            <div-->
        <!--              class="header__controls-counter header__controls-counter&#45;&#45;blue"-->
        <!--            >-->
        <!--              2-->
        <!--            </div>-->
        <!--            <icon name="header__controls-link-5" />-->
        <!--          </a>-->
        <!--          <div class="tooltip bot">ישיבות (בקרוב)</div>-->
        <!--        </li>-->
        <li class="header__controls-item">
          <router-link
            class="header__controls-link"
            active-class="active"
            to="/board-draw"
            tabindex="0"
          >
            <div class="header__controls-counter" />
            <icon name="header__controls-link-6" />
          </router-link>
          <div class="tooltip bot">לוח ציור</div>
        </li>
        <li class="header__controls-item" v-if="!isStudent">
          <router-link
            class="header__controls-link"
            active-class="active"
            to="/chat"
            tabindex="0"
          >
            <div
              v-if="user.unreadMessages && user.unreadMessages > 0"
              class="header__controls-counter header__controls-counter--red"
            >
              {{ user.unreadMessages }}
            </div>
            <icon name="header__controls-link-10" />
          </router-link>
          <div class="tooltip bot">הודעות</div>
        </li>
      </ul>

      <a @click="$router.go(-1)" class="header__back-btn d-none d-lg-flex">
        <icon name="header__controls-link-7" />
        <div class="tooltip bot">חזור</div>
      </a>
      <!--      <ul class="header__nav d-none d-lg-flex">-->
      <!--        <li class="header__nav-item">-->
      <!--          <router-link to="/" class="header__nav-link">-->
      <!--            <icon name="header__controls-link-8" />-->
      <!--          </router-link>-->
      <!--          <div class="tooltip bot">מסך ראשי (בקרוב)</div>-->
      <!--        </li>-->
      <!--        <template v-if="selectedCampus">-->
      <!--          <template v-for="(menu_item, index) in menu_items">-->
      <!--            <li-->
      <!--              v-if="typeof menu_item.show == 'boolean' ? menu_item.show : true"-->
      <!--              :key="index"-->
      <!--              :class="-->
      <!--                'header__nav-item ' +-->
      <!--                (part == menu_item.active ? ' active ' : '')-->
      <!--              "-->
      <!--            >-->
      <!--              <router-link-->
      <!--                :to="{ name: menu_item.route_name }"-->
      <!--                :class="-->
      <!--                  'header__nav-link ' +-->
      <!--                  (menu_item.route_name == '' ? ' no-active ' : '')-->
      <!--                "-->
      <!--              >-->
      <!--                {{ menu_item.name }}-->
      <!--              </router-link>-->
      <!--            </li>-->
      <!--          </template>-->
      <!--        </template>-->
      <!--      </ul>-->
      <div
        class="school-switcher mr-auto"
        :class="{
          active: showCampusSelect
        }"
      >
        <router-link
          v-if="selectedCampus"
          :to="{ name: 'HomePage' }"
          href=""
          class="school-switcher__current"
        >
          <img v-if="selectedCampus.logo" :src="selectedCampus.logo" alt="" />
          <span v-else>{{ selectedCampus.text }}</span>
        </router-link>
        <div
          v-if="campuses.length > 1"
          class="school-switcher__arr"
          :style="{
            pointerEvents: showCampusSelect ? 'none' : 'auto'
          }"
          @click="$hold(() => (showCampusSelect = true))"
        >
          <icon name="duration-minus-1" width="16" height="16" />
        </div>
        <ul
          v-click-outside="() => (showCampusSelect = false)"
          class="school-switcher__list"
        >
          <li
            v-for="campus of campuses"
            :key="campus.id"
            class="school-switcher__list-item"
            :class="{
              active: selectedCampus ? selectedCampus.id === campus.id : false
            }"
            @click="selectCampus(campus)"
          >
            <div class="school-switcher__list-item-logo">
              <img v-if="campus.logo" :src="campus.logo" alt="" />
              <img v-else src="/images/sm-logo.svg" alt="" />
            </div>
            <div class="school-switcher__list-item-info">
              <div class="school-switcher__list-item-title">
                {{ campus.text }}
              </div>
              <div class="school-switcher__list-item-text">פנימייה</div>
            </div>
          </li>
        </ul>
      </div>
    </header>
    <div class="menu" :class="{ active: showMenu }">
      <div class="menu__header">
        <a href="" class="menu__logo">
          <img src="/images/sm-logo-white.svg" alt="" />
        </a>
        <div class="menu__toggle-btn" @click="changeShowMenu(!showMenu)">
          <icon name="menu-new-icon" />
        </div>
      </div>
      <NewMenu :user="user" @logout="logout" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { createPopper } from '@popperjs/core';
import NewMenu from '@/Components/Layout/NewMenu';

export default {
  name: 'TheHeader',
  components: { NewMenu },
  props: {
    showLogoMenu: {
      type: Boolean,
      default: false
    },
    showMenu: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showQRPopup: false,
      showCampusSelect: false,
      popper: undefined
    };
  },
  computed: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    isStudent() {
      return this.$store.getters['auth/user'].entity_id === 2;
    },
    ...mapState({
      campuses: s => s.settings.campuses,
      selectedCampus: s => s.settings.selectedCampus
    }),
    ...mapGetters({ user: 'auth/user', settings: 'settings/getSettings' }),
    part() {
      return this.$route.meta.part ? this.$route.meta.part : false;
    },
    showSidebar() {
      return this.$store.getters['front/getSidebarStatus'];
    },
    isDirector() {
      const user = this.$store.state.auth.user;

      if (user) {
        return [0, 1].includes(user.entity_id);
      }

      return false;
    },
    newMenu() {
      return [
        [
          {
            name: 'עובדים',
            img: 'menu-new-icon-3',
            url: '/workers-list',
            show: this.$perm('worker_list.show', this.selectedCampus?.id)
          }
        ],
        [
          {
            name: 'תלמידים',
            img: 'menu-new-icon-2',
            url: '/student-list',
            show: this.$perm('student.list', this.selectedCampus?.id)
          },
          {
            name: 'נוכחות',
            img: 'menu-new-icon-10',
            url: '/reports',
            show:
              this.$perm('report.list', this.selectedCampus?.id) ||
              this.$perm('report.show', this.selectedCampus?.id)
          },
          {
            name: 'אישורים',
            img: 'menu-new-icon-11',
            url: '/students-security',
            show: this.$perm('student.view_parents', this.selectedCampus?.id)
          },
          {
            name: 'אירועים',
            img: 'menu-new-icon-12',
            url: '/incident-blanks',
            show: this.$perm(
              'student.view_behavior_incidents',
              this.selectedCampus?.id
            )
          }
        ],
        [
          {
            name: 'למידה',
            img: 'centers-default',
            url: '/centers/:slug/day',
            show: this.$perm('study_center.can_show', this.selectedCampus?.id)
          }
        ],
        [
          {
            name: 'אחזקה',
            img: 'menu-new-icon-9',
            url: '/service-orders',
            show: this.$perm('service_orders.create', this.selectedCampus?.id)
          },
          {
            name: 'ביטחון',
            img: 'menu-new-icon-5',
            url: '/security/entry',
            show: this.$perm('security.can_view', this.selectedCampus?.id)
          },
          {
            name: 'מבקרים',
            img: 'menu-new-icon-4',
            url: '/own-permission',
            show: this.$perm('security.can_view', this.selectedCampus?.id)
          }
        ],
        [
          {
            name: 'הגדרות',
            img: 'menu-new-icon-8',
            url: '/settings',
            show: this.$perm('settings.view', this.selectedCampus.id)
          }
        ]
      ];
    }
  },
  watch: {
    showCampusSelect(v) {
      if (this.popper) {
        this.popper.destroy();
      }
      this.$nextTick(() => {
        const button = this.$refs['sub-dropdown-btn'];
        const element = this.$refs['sub-dropdown'];
        if (button && element) {
          this.popper = createPopper(button, element, {
            placement: 'bottom',
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [-18, 0]
                }
              }
            ]
          });
        }
      });
    },
    $route(v) {
      if (+v.query['open-menu'] === 1) {
        this.hideSidebar(true);
      }
    }
  },
  mounted() {
    this.CHANGE_SELECTED_CAMPUS_LIST();
  },
  methods: {
    ...mapActions({
      signOut: 'auth/signOut',
      setSidebarStatus: 'front/setSidebarStatus',
      CHANGE_SELECTED_CAMPUS_LIST: 'settings/CHANGE_SELECTED_CAMPUS_LIST'
    }),
    changeShowMenu(menu) {
      this.$emit('showMenu', menu);
    },
    showUserAvatar(state) {
      if (state) {
        this.$emit('isCloseUserAvatar', false);
      }
      if (this.showLogoMenu === false) {
        this.$emit('isCloseUserAvatar', true);
      }
      if (this.showLogoMenu === true) {
        this.$emit('isCloseUserAvatar', false);
      }
    },
    closeUserAvatarHeader() {
      this.$emit('isCloseUserAvatar', false);
    },
    async logout() {
      await this.signOut();
    },
    hideSidebar($event, value = true) {
      this.setSidebarStatus(value);
      localStorage.setItem('showMenu', value);
      if (this.isMobile && value === true) {
        this.$router.push({
          path: this.$route.fullPath,
          query: { 'open-menu': 1 }
        });
      }
    },
    showMenuHeader() {
      this.changeShowMenu(true);
      this.hideSidebar(null, false);
    },
    selectCampus(campus) {
      this.$store.commit('settings/SET_SELECTED_CAMPUS', campus);
      this.showCampusSelect = false;
    }
  }
};
</script>
